/**
 * Computes SP ROAS (1-day) from attributed ops and revenue impact.
 * Centralized here to avoid duplicating the formula across components.
 */
export function computeSpRoas(
  spAttributedOps1day: number | null | undefined,
  spRevenueImpact: number | null | undefined
): number | null {
  return spAttributedOps1day && spRevenueImpact
    ? Math.round((spAttributedOps1day / spRevenueImpact) * 100) / 100
    : null;
}

export function getMetricsData(weblab: any, data: any) {
  data.sp_revenue_impact += weblab.data.sp_revenue_impact;
  // @ts-ignore
  data.sp_revenue_impact_expected += weblab.data.sp_revenue_impact;
  // @ts-ignore
  data.sp_revenue_impact_expected_lift +=
    weblab.data.sp_revenue_impact * weblab.data.sp_revenue_lift;

  data.ops_impact += weblab.data.ops_impact;
  // @ts-ignore
  data.ops_impact_expected += weblab.data.ops_impact;
  // @ts-ignore
  data.ops_impact_expected_lift +=
    weblab.data.ops_impact * weblab.data.ops_lift;

  data.gccp_impact += weblab.data.gccp_impact;
  // @ts-ignore
  data.gccp_impact_expected += weblab.data.gccp_impact;
  // @ts-ignore
  data.gccp_impact_expected_lift +=
    weblab.data.gccp_impact * weblab.data.gccp_lift;

  // @ts-ignore
  data.net_cp_impact += weblab.data.net_cp_impact;
  // @ts-ignore
  data.net_cp_impact_expected += weblab.data.net_cp_impact;
  // @ts-ignore
  data.net_cp_impact_expected_lift +=
    weblab.data.net_cp_impact * weblab.data.net_cp_lift;

  data.sp_clicks_impact += weblab.data.sp_clicks_impact;
  // @ts-ignore
  data.sp_clicks_impact_expected += weblab.data.sp_clicks_impact;
  // @ts-ignore
  data.sp_clicks_impact_expected_lift +=
    weblab.data.sp_clicks_impact * weblab.data.sp_clicks_lift;

  data.paid_units_impact += weblab.data.paid_units_impact;
  // @ts-ignore
  data.paid_units_impact_expected += weblab.data.paid_units_impact;
  // @ts-ignore
  data.paid_units_impact_expected_lift +=
    weblab.data.paid_units_impact * weblab.data.paid_units_lift;

  data.csales_impact += weblab.data.csales_impact;
  // @ts-ignore
  data.csales_impact_expected += weblab.data.csales_impact;
  // @ts-ignore
  data.csales_impact_expected_lift +=
    weblab.data.csales_impact * weblab.data.csales_lift;

  data.sb_revenue_impact += weblab.data.sb_revenue_impact;
  // @ts-ignore
  data.sb_revenue_impact_expected += weblab.data.sb_revenue_impact;
  // @ts-ignore
  data.sb_revenue_impact_expected_lift +=
    weblab.data.sb_revenue_impact * weblab.data.sb_revenue_lift;

  data.sb_clicks_impact += weblab.data.sb_clicks_impact;
  // @ts-ignore
  data.sb_clicks_impact_expected += weblab.data.sb_clicks_impact;
  // @ts-ignore
  data.sb_clicks_impact_expected_lift +=
    weblab.data.sb_clicks_impact * weblab.data.sb_clicks_lift;

  // @ts-ignore
  data.sp_attributed_ops_1day_expected += weblab.data.sp_attributed_ops_1day;

  // SP ROAS (1-day): use first non-null value (ratio metric, not additive)
  if (data.sp_roas_1day_value === null && weblab.data.sp_roas_1day != null) {
    data.sp_roas_1day_value = weblab.data.sp_roas_1day;
  }
}

export function buildMetricsArray(metrics: Array<any>, data: any) {
  metrics.push({
    label: "",
    impact: "Impact",
  });
  metrics.push({
    label: "SP Revenue",
    impact:
      data.sp_revenue_impact_expected === 0
        ? null
        : data.sp_revenue_impact_expected,
  });
  metrics.push({
    label: "OPS",
    impact: data.ops_impact_expected === 0 ? null : data.ops_impact_expected,
  });
  metrics.push({
    label: "GCCP",
    impact: data.gccp_impact_expected === 0 ? null : data.gccp_impact_expected,
  });
  metrics.push({
    label: "Net CP",
    impact:
      data.net_cp_impact_expected === 0 ? null : data.net_cp_impact_expected,
  });
  metrics.push({
    label: "SP Clicks",
    impact:
      data.sp_clicks_impact_expected === 0
        ? null
        : data.sp_clicks_impact_expected,
  });
  metrics.push({
    label: "Paid Units",
    impact:
      data.paid_units_impact_expected === 0
        ? null
        : data.paid_units_impact_expected,
  });
  metrics.push({
    label: "CSales",
    impact:
      data.csales_impact_expected === 0 ? null : data.csales_impact_expected,
  });
  metrics.push({
    label: "SP Attr. OPS (1-day)",
    impact:
      data.sp_attributed_ops_1day_expected === 0
        ? null
        : data.sp_attributed_ops_1day_expected,
  });
  metrics.push({
    label: "SP ROAS (1-day)",
    impact: data.sp_roas_1day_value,
  });
  metrics.push({
    label: "SB Revenue",
    impact:
      data.sb_revenue_impact_expected === 0
        ? null
        : data.sb_revenue_impact_expected,
  });
  metrics.push({
    label: "SB Clicks",
    impact:
      data.sb_clicks_impact_expected === 0
        ? null
        : data.sb_clicks_impact_expected,
  });
}
